import { createFileRoute, useParams } from '@tanstack/react-router';
import { Suspense } from 'react';
import HStack from '@/components/Layout/HStack';
import VStack from '@/components/Layout/VStack';
import type { NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import NavigationCard from '@/components/Navigation/NavigationCard';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useInboundAggregateDataPipelineDetail } from '../../-query';
import { BasicInfoSection } from './-components/BasicInfoSection';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/')({
  component: BasicInfo
});
function BasicInfo() {
  return <Suspense>
      <Content />
    </Suspense>;
}
function Content() {
  const {
    id
  } = useParams({
    from: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail'
  });
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.inboundAggregateDataPipeline.detail'
  });
  useDocumentTitle(t('basicInfo.title'));
  const {
    data
  } = useInboundAggregateDataPipelineDetail(id);
  const navigationSections: NavigationSectionGroup[] = [{
    titleLabel: t('basicInfo.title'),
    to: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info',
    hash: 'basic-info'
  }];
  return <HStack className="gap-0 px-12 py-6">
      <div className="sticky top-6 w-52 shrink-0">
        <NavigationCard sections={navigationSections} />
      </div>

      <VStack className="flex-1 gap-6">
        <BasicInfoSection pipelineId={id} data={data} />
      </VStack>
    </HStack>;
}